/* Vся редактируемая информация сайта в одном месте.
   В будущем эти данные будут редактироваться через админку. */

export const BRAND = {
  name: "ЩЁТКА",
  tagline: "Мастерская обуви",
  slogan: "Чистим / Чиним / Красим",
  description:
    "Возвращаем обуви первозданный вид. Премиальный ремесленный сервис с заботой о каждой паре — от классики до редкого винтажа.",
};

export const CONTACTS = {
  master: "Пётр Иванов",
  position: "Старший Мастер-Реставратор",
  phone: "+7 910 235-87-58",
  phoneRaw: "+79102358758",
  email: "petr@shchetka-shoes.ru",
  address: "г. Брянск, ул. Объездная, 30 (1 этаж)",
  hours: [
    { day: "Пн — Пт", time: "10:00 — 20:00" },
    { day: "Сб — Вс", time: "11:00 — 18:00" },
  ],
  socials: [
    { label: "Telegram", url: "#" },
    { label: "WhatsApp", url: "#" },
    { label: "Instagram", url: "#" },
  ],
};

export const ADVANTAGES = [
  {
    n: "01",
    title: "Опыт 14 лет",
    text: "За плечами тысячи восстановленных пар: от классических оксфордов до люксовых кед.",
  },
  {
    n: "02",
    title: "Ручная работа",
    text: "Никаких конвейеров. Каждая пара проходит через руки мастера и осмотр в три этапа.",
  },
  {
    n: "03",
    title: "Гарантия результата",
    text: "Если итог вас не устроил — переделаем бесплатно или вернём деньги. Без вопросов.",
  },
  {
    n: "04",
    title: "Премиум-материалы",
    text: "Saphir, Famaco, Collonil — работаем только с проверенными европейскими составами.",
  },
];

export const SERVICES = [
  {
    slug: "cleaning",
    icon: "Sparkles",
    title: "Химчистка",
    short: "Глубокая очистка кожи, замши, нубука и текстиля.",
    description:
      "Удаляем соль, грязь и старые крема. Восстанавливаем структуру материала и устраняем запахи без агрессии и без потери цвета. Работаем с кроссовками, ботинками и кожаными сумками.",
    duration: "1 — 3 дня",
    priceFrom: 700,
  },
  {
    slug: "restoration",
    icon: "Hammer",
    title: "Реставрация",
    short: "Возвращаем геометрию, цвет и характер.",
    description:
      "Реставрация потёртостей, порезов и урезов; растяжка по ноге, латки и точечное восстановление кожи. Возвращаем парам опрятный вид без переплат.",
    duration: "3 — 7 дней",
    priceFrom: 400,
  },
  {
    slug: "repair",
    icon: "Wrench",
    title: "Ремонт",
    short: "Набойки, профилактика, фурнитура.",
    description:
      "Замена набоек, профилактика подошвы, прошивка/проклейка, замена молний, задников, стелек, супинаторов и кожаных элементов. Работаем со сложными конструктивными случаями.",
    duration: "1 — 5 дней",
    priceFrom: 400,
  },
  {
    slug: "painting",
    icon: "Palette",
    title: "Покраска",
    short: "Подбор оттенка и полная перекраска.",
    description:
      "Полная и частичная покраска кожаной и замшевой обуви, подбор оттенка один-в-один, дополнительные цвета. Работаем и с сумками: полная или локальная покраска плюс реставрация урезов.",
    duration: "3 — 7 дней",
    priceFrom: 1100,
  },
];

export const PRICES = [
  {
    category: "Чистка и уход",
    rows: [
      { service: "Чистка стандарт", price: "2 500 ₽" },
      { service: "Чистка ботинок", price: "2 700 ₽" },
      { service: "Чистка высокой обуви", price: "2 900 ₽" },
      { service: "Чистка подошвы", price: "700 ₽" },
      { service: "Отбеливание подошвы", price: "1 100 ₽" },
      { service: "Уход за классической обувью", price: "2 200 ₽" },
    ],
  },
  {
    category: "Покраска",
    rows: [
      { service: "Покраска кожаной обуви — основной цвет", price: "2 000 ₽" },
      { service: "Частичная покраска кожаной обуви", price: "1 100 ₽" },
      { service: "Покраска замшевой обуви", price: "2 000 ₽" },
      { service: "Покраска подошвы", price: "2 000 ₽" },
      { service: "Дополнительный цвет", price: "+600 ₽" },
      { service: "Срочность", price: "+600 ₽" },
    ],
  },
  {
    category: "Реставрация",
    rows: [
      { service: "Реставрация потёртостей и порезов", price: "от 600 ₽" },
      { service: "Реставрация урезов", price: "от 400 ₽" },
      { service: "Латка", price: "от 400 ₽" },
      { service: "Растяжка обуви", price: "от 900 ₽" },
    ],
  },
  {
    category: "Ремонт",
    rows: [
      { service: "Набойки", price: "600 — 1 100 ₽" },
      { service: "Профилактика подошвы", price: "1 400 — 2 200 ₽" },
      { service: "Прошивка подошвы", price: "1 100 ₽" },
      { service: "Проклейка подошвы", price: "1 100 ₽" },
      { service: "Подклейка", price: "400 — 600 ₽" },
      { service: "Замена мягкого задника", price: "2 200 — 4 400 ₽" },
      { service: "Замена жёсткого задника", price: "2 200 — 4 400 ₽" },
      { service: "Замена молнии", price: "от 600 ₽" },
      { service: "Замена жёсткой стельки", price: "1 100 ₽" },
      { service: "Замена мягкой стельки", price: "1 100 ₽" },
      { service: "Замена кожаного элемента", price: "от 600 ₽" },
      { service: "Перетяжка каблука", price: "от 2 200 ₽" },
      { service: "Укрепление каблука", price: "от 400 ₽" },
      { service: "Замена супинатора", price: "от 700 ₽" },
    ],
  },
  {
    category: "Сумки",
    rows: [
      { service: "Чистка сумки", price: "от 3 300 ₽" },
      { service: "Покраска сумки", price: "от 3 300 ₽" },
      { service: "Частичная покраска сумки", price: "от 1 700 ₽" },
      { service: "Реставрация урезов", price: "от 400 ₽" },
    ],
  },
];

export const BEFORE_AFTER = [
  {
    title: "Кроссовки BOSS",
    before: "/images/before_1.jpg",
    after: "/images/after_1.jpg",
    note: "Глубокая химчистка кожи и отбеливание подошвы",
  },
  {
    title: "Кожаная пара",
    before: "/images/before_2.jpg",
    after: "/images/after_2.jpg",
    note: "Чистка, реставрация потёртостей и финишная полировка",
  },
  {
    title: "Зимние ботинки",
    before: "/images/before_3.jpg",
    after: "/images/after_3.jpg",
    note: "Удаление соли и грязи, восстановление цвета кожи",
  },
  {
    title: "Замшевая пара",
    before: "/images/before_4.jpg",
    after: "/images/after_4.jpg",
    note: "Восстановление ворса и покраска",
  },
];

export const ABOUT = {
  intro:
    "Наша мастерская — это пространство профессионального ухода за обувью и кожаными изделиями, где внимание к деталям и уважение к материалу стоят на первом месте.",
  body:
    "Более 5 лет мы работаем с изделиями разного уровня — от повседневных до премиальных и коллекционных. Опыт взаимодействия с дорогими брендами сформировал у нас высокий стандарт качества: точность в работе, деликатность в обработке и безупречный результат. Мы специализируемся на полном цикле услуг: глубокая химчистка с учётом особенностей каждого материала, реставрация и восстановление внешнего вида, ремонт любой сложности (включая сложные конструктивные работы), профессиональный уход и защита. Каждое изделие для нас — не просто вещь, а объект с ценностью, историей и характером. Наша философия — возвращать вещам их первоначальный вид и продлевать срок их службы, сохраняя эстетику и качество, заложенные производителем.",
  signature: "Мастерская «Щётка»",
};

export const MEDIA = {
  hero_illustration: "/images/logo-shchetka.jpg",
  paper_texture: "/images/paper-texture.png",
  hero_photo: "/images/polished-shoe.png",
  workshop:
    "https://images.pexels.com/photos/20993731/pexels-photo-20993731.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  tools:
    "https://images.unsplash.com/photo-1777177967028-bd91fe0954a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxjb2JibGVyJTIwdG9vbHMlMjBsZWF0aGVyJTIwY3JhZnQlMjB2aW50YWdlfGVufDB8fHx8MTc3NzM5NzE2NHww&ixlib=rb-4.1.0&q=85",
};

export const NAV_LINKS = [
  { id: "services", label: "Услуги" },
  { id: "prices", label: "Прайс" },
  { id: "before-after", label: "Работы" },
  { id: "about", label: "О нас" },
  { id: "contacts", label: "Контакты" },
];
